<div class="col-12">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
                 size="medium"
                 color="#fff"
                 type="line-spin-clockwise-fade"
                 [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="row">
        <div class="col-12">
            <h2 class="page-title" tabindex="0">{{'user.add_user' | translate}}</h2>
        </div>
        <div class="col-12 mb-2">
            <xng-breadcrumb separator=" > ">
                <ng-container *xngBreadcrumbItem="let breadcrumb">
                    <span *ngIf="breadcrumb">
                        {{ 'breadcrumb.' + breadcrumb | translate }}
                    </span>
                </ng-container>
            </xng-breadcrumb>
        </div>
    </div>

    <form [formGroup]="addUserForm" class="profile-form" (ngSubmit)="addUserSave()" name="form">

        <!-- Two-column grid -->
        <div class="card-grid">

            <!-- Personal Information Card -->
            <div class="profile-card">
                <div class="card-header-section">
                    <h3 class="card-title">{{'profile.personal_info' | translate}}</h3>
                </div>
                <hr>
                <div class="card-body-section">
                    <div class="field-group" *ngIf="picturePreview">
                        <img [src]="picturePreview ? picturePreview : 'assets/images/default-user.jpeg'" alt="{{'user.user_profile_picture' | translate}}" width="120" height="120" class="img-round"/>
                    </div>
                    <div class="field-group">
                        <div class="">
                            <span>{{'user.profile_picture' | translate}}</span>
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="customFileLang" [lang]="lang" title="{{'general.select' | translate}}"
                                    (change)="handleProfilePictureUpload($event.target.files)">
                                <div class="custom-file-label custom-label-user" for="customFileLang" id="fileLabel" title="{{'general.select' | translate}}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="field-group">
                        <label for="firstName" class="field-label">{{'user.first_name' | translate}}<span class="required-mark">*</span></label>
                        <input id="firstName" type="text" formControlName="firstName" class="form-control modern-input"
                               [ngClass]="{ 'is-valid': isFieldValid('firstName'), 'is-invalid': isFieldInvalid('firstName') }"
                               maxlength="50" />
                        <ng-container *ngIf="isFieldInvalid('firstName')">
                            <div *ngIf="hasError('firstName', 'required')" class="field-error">{{'general.required_field' | translate}}</div>
                            <div *ngIf="!hasError('firstName', 'required')" class="field-error">{{'error.name' | translate}}</div>
                        </ng-container>
                    </div>
                    <div class="field-group">
                        <label for="lastName" class="field-label">{{'user.last_name' | translate}}<span class="required-mark">*</span></label>
                        <input id="lastName" type="text" formControlName="lastName" class="form-control modern-input"
                               [ngClass]="{ 'is-valid': isFieldValid('lastName'), 'is-invalid': isFieldInvalid('lastName') }"
                               maxlength="50" />
                        <ng-container *ngIf="isFieldInvalid('lastName')">
                            <div *ngIf="hasError('lastName', 'required')" class="field-error">{{'general.required_field' | translate}}</div>
                            <div *ngIf="!hasError('lastName', 'required')" class="field-error">{{'error.name' | translate}}</div>
                        </ng-container>
                    </div>
                    <div class="field-group">
                        <label for="email" class="field-label">{{'general.email' | translate}}<span class="required-mark">*</span></label>
                        <div class="input-icon-wrapper">
                            <i class="fa fa-envelope input-icon"></i>
                            <input id="email" type="email" formControlName="email" class="form-control modern-input input-with-icon"
                                   [ngClass]="{ 'is-valid': isFieldValid('email'), 'is-invalid': isFieldInvalid('email') }"
                                   maxlength="320" />
                        </div>
                        <ng-container *ngIf="isFieldInvalid('email')">
                            <div *ngIf="hasError('email', 'required')" class="field-error">{{'general.required_field' | translate}}</div>
                            <div *ngIf="!hasError('email', 'required') && hasError('email', 'pattern')" class="field-error">{{'general.invalid_format' | translate}}</div>
                        </ng-container>
                    </div>
                    <div class="inline-fields">
                        <div class="field-group flex-1">
                            <label for="dob" class="field-label">{{'user.dob' | translate}}</label>
                            <mat-form-field class="modern-datepicker w-100">
                                <input matInput id="dob" [matDatepicker]="picker" formControlName="dob"
                                       [min]="minDate" [max]="currentDate" [(ngModel)]="dobDate" readonly>
                                <span matSuffix class="dob-suffix">
                                    <button class="dob-clear-btn" type="button"
                                            title="{{'user.clear_dob' | translate}}" (click)="clearDobDate()">
                                        <i class="fa fa-times"></i>
                                    </button>
                                    <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                                </span>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="field-group flex-1">
                            <label for="gender" class="field-label">{{'user.gender' | translate}}</label>
                            <select class="form-control modern-input" id="gender" name="gender" formControlName="gender">
                                <option selected value="">{{'roles.select' | translate}}</option>
                                <option value="M">{{'user.male' | translate}}</option>
                                <option value="F">{{'user.female' | translate}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- Role selector -->
                    <div class="field-group">
                        <label for="role" class="field-label">{{'general.role' | translate}}<span class="required-mark">*</span></label>
                        <select class="form-control modern-input" id="role" name="role" formControlName="role"
                                [ngClass]="{ 'is-valid': isFieldValid('role'), 'is-invalid': isFieldInvalid('role') }">
                            <option disabled selected value="">{{'roles.select' | translate}}</option>
                            <option value="User">{{'roles.User' | translate}}</option>
                            <option value="SecurityAgent">{{'roles.sec_agent' | translate}}</option>
                            <option value="Supervisor">{{'roles.Supervisor' | translate}}</option>
                            <option value="Admin">{{'roles.Admin' | translate}}</option>
                        </select>
                        <ng-container *ngIf="isFieldInvalid('role')">
                            <div *ngIf="hasError('role', 'required')" class="field-error">{{'general.required_field' | translate}}</div>
                        </ng-container>
                    </div>
                    <div class="">
                    <div class="field-group">
                        <label for="motorVehicle" class="field-label">{{'profile.motor_vehicle' | translate}}</label>
                        <input id="motorVehicle" type="text" formControlName="motorVehicle" class="form-control modern-input" maxlength="100" />
                    </div>
                    <div class="field-group">
                        <label for="children" class="field-label">{{'profile.children' | translate}}</label>
                        <input id="children" type="number" formControlName="children" class="form-control modern-input" min="0" />
                    </div>
                    <div class="field-group">
                        <label for="odim" class="field-label">{{'profile.odim' | translate}}</label>
                        <input id="odim" type="text" formControlName="odim" class="form-control modern-input" maxlength="100" />
                    </div>
                    </div>
                </div>
            </div>

            <!-- Phone & SMS Consent Card -->
            <div class="profile-card">
                <div class="card-header-section">
                    <h3 class="card-title">{{'profile.phone_sms' | translate}}</h3>
                </div>
                <hr>
                <div class="card-body-section">
                    <div class="field-group">
                        <label for="phoneNumber" class="field-label">{{'general.phone_number' | translate}}<span class="required-mark">*</span></label>
                        <div class="input-icon-wrapper">
                            <i class="fa fa-mobile input-icon"></i>
                            <input id="phoneNumber" type="text" formControlName="phoneNumber" class="form-control modern-input input-with-icon"
                                   [ngClass]="{ 'is-valid': isFieldValid('phoneNumber'), 'is-invalid': isFieldInvalid('phoneNumber') }"
                                   maxlength="20" />
                        </div>
                        <ng-container *ngIf="isFieldInvalid('phoneNumber')">
                            <div *ngIf="hasError('phoneNumber', 'required')" class="field-error">{{'general.required_field' | translate}}</div>
                            <div *ngIf="!hasError('phoneNumber', 'required')" class="field-error">{{'general.invalid_phone_format' | translate}}</div>
                        </ng-container>
                    </div>

                    <!-- SMS Consent / Twilio 10DLC -->
                    <div class="consent-box" [ngClass]="{'consent-active': smsConsent}">
                        <h4 class="consent-heading">{{'profile.sms_consent_heading' | translate}}</h4>
                        <p class="consent-description">
                            {{'profile.sms_consent_description' | translate}}
                        </p>
                        <div class="consent-checkbox-wrapper">
                            <input type="checkbox" id="smsConsent" class="consent-checkbox" formControlName="sendSms" (change)="smsConsent = !smsConsent"/>
                            <label for="smsConsent" class="consent-label">
                                {{'profile.sms_consent_title' | translate}}
                            </label>
                        </div>
                        <p class="consent-legal">
                            {{'profile.sms_consent_legal' | translate}}
                            <a href="/termsService" target="_blank" rel="noopener" class="consent-link">
                                {{'register.terms_of_service' | translate}}
                                <span class="screen-reader-only">({{'general.opens_new_tab' | translate}})</span>
                                <i class="fa fa-external-link ml-1" aria-hidden="true"></i>
                            </a>
                            {{'register.and' | translate}}
                            <a href="/privacyPolicy" target="_blank" rel="noopener" class="consent-link">
                                {{'register.privacy_policy' | translate}}
                                <span class="screen-reader-only">({{'general.opens_new_tab' | translate}})</span>
                                <i class="fa fa-external-link ml-1" aria-hidden="true"></i>
                            </a>.
                        </p>
                    </div>

                    <div class="field-group residence-phone-group">
                        <label for="phoneNumberResidence" class="field-label">{{'user.res_phone_number' | translate}}</label>
                        <div class="input-icon-wrapper">
                            <i class="fa fa-phone input-icon"></i>
                            <input id="phoneNumberResidence" type="text" formControlName="phoneNumberResidence" class="form-control modern-input input-with-icon"
                                   [ngClass]="{ 'is-valid': isFieldValid('phoneNumberResidence'), 'is-invalid': isFieldInvalid('phoneNumberResidence') }"
                                   maxlength="20" />
                        </div>
                        <ng-container *ngIf="isFieldInvalid('phoneNumberResidence')">
                            <div class="field-error">{{'general.invalid_phone_format' | translate}}</div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Address Card -->
            <div class="profile-card">
                <div class="card-header-section">
                    <h3 class="card-title">{{'profile.address_info' | translate}}</h3>
                </div>
                <hr>
                <div class="card-body-section">
                    <div class="field-group">
                        <label for="address" class="field-label">{{'user.address' | translate}}</label>
                        <input id="address" type="text" formControlName="address" class="form-control modern-input"
                               [ngClass]="{ 'is-valid': isFieldValid('address'), 'is-invalid': isFieldInvalid('address') }"
                               maxlength="150" />
                        <ng-container *ngIf="isFieldInvalid('address')">
                            <div class="field-error">{{'error.address' | translate}}</div>
                        </ng-container>
                    </div>
                    <div class="inline-fields">
                        <div class="field-group flex-1">
                            <label for="city" class="field-label">{{'user.city' | translate}}</label>
                            <input id="city" type="text" formControlName="city" class="form-control modern-input"
                                   [ngClass]="{ 'is-valid': isFieldValid('city'), 'is-invalid': isFieldInvalid('city') }"
                                   maxlength="60" />
                            <ng-container *ngIf="isFieldInvalid('city')">
                                <div class="field-error">{{'error.address' | translate}}</div>
                            </ng-container>
                        </div>
                        <div class="field-group flex-1">
                            <label for="state" class="field-label">{{'user.state' | translate}}</label>
                            <input id="state" type="text" formControlName="state" class="form-control modern-input"
                                   [ngClass]="{ 'is-valid': isFieldValid('state'), 'is-invalid': isFieldInvalid('state') }"
                                   maxlength="60" />
                            <ng-container *ngIf="isFieldInvalid('state')">
                                <div class="field-error">{{'error.address' | translate}}</div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="inline-fields">
                        <div class="field-group flex-1">
                            <label for="country" class="field-label">{{'user.country' | translate}}</label>
                            <input id="country" type="text" formControlName="country" class="form-control modern-input"
                                   [ngClass]="{ 'is-valid': isFieldValid('country'), 'is-invalid': isFieldInvalid('country') }"
                                   maxlength="60" />
                            <ng-container *ngIf="isFieldInvalid('country')">
                                <div class="field-error">{{'error.address' | translate}}</div>
                            </ng-container>
                        </div>
                        <div class="field-group flex-1">
                            <label for="zip" class="field-label">{{'user.zip_code' | translate}}</label>
                            <input id="zip" type="text" formControlName="zip" class="form-control modern-input"
                                   [ngClass]="{ 'is-valid': isFieldValid('zip'), 'is-invalid': isFieldInvalid('zip') }"
                                   maxlength="5" />
                            <ng-container *ngIf="isFieldInvalid('zip')">
                                <div class="field-error">{{'error.numbers_only' | translate}}</div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Emergency Contacts Card -->
            <div class="profile-card">
                <div class="card-header-section">
                    <h3 class="card-title">{{'profile.emergency_contacts' | translate}}</h3>
                </div>
                <hr>
                <div class="card-body-section">
                    <!-- Primary Contact -->
                    <div class="contact-block">
                        <span class="contact-badge">{{'profile.primary' | translate}}</span>
                        <div class="inline-fields">
                            <div class="field-group flex-1">
                                <label for="primaryContactName" class="field-label">{{'user.pri_con_name' | translate}}</label>
                                <input id="primaryContactName" type="text" formControlName="primaryContactName" class="form-control modern-input"
                                       [ngClass]="{ 'is-valid': isFieldValid('primaryContactName'), 'is-invalid': isFieldInvalid('primaryContactName') }"
                                       maxlength="50" />
                                <ng-container *ngIf="isFieldInvalid('primaryContactName')">
                                    <div class="field-error">{{'error.name' | translate}}</div>
                                </ng-container>
                            </div>
                            <div class="field-group flex-1">
                                <label for="primaryContactPhoneNumber" class="field-label">{{'user.pri_con_phone' | translate}}</label>
                                <div class="input-icon-wrapper">
                                    <i class="fa fa-phone input-icon"></i>
                                    <input id="primaryContactPhoneNumber" type="text" formControlName="primaryContactPhoneNumber"
                                           class="form-control modern-input input-with-icon"
                                           [ngClass]="{ 'is-valid': isFieldValid('primaryContactPhoneNumber'), 'is-invalid': isFieldInvalid('primaryContactPhoneNumber') }"
                                           maxlength="20" />
                                </div>
                                <ng-container *ngIf="isFieldInvalid('primaryContactPhoneNumber')">
                                    <div class="field-error">{{'general.invalid_phone_format' | translate}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <!-- Secondary Contact -->
                    <div class="contact-block">
                        <span class="contact-badge secondary">{{'profile.secondary' | translate}}</span>
                        <div class="inline-fields">
                            <div class="field-group flex-1">
                                <label for="secondaryContactName" class="field-label">{{'user.sec_con_name' | translate}}</label>
                                <input id="secondaryContactName" type="text" formControlName="secondaryContactName" class="form-control modern-input"
                                       [ngClass]="{ 'is-valid': isFieldValid('secondaryContactName'), 'is-invalid': isFieldInvalid('secondaryContactName') }"
                                       maxlength="50" />
                                <ng-container *ngIf="isFieldInvalid('secondaryContactName')">
                                    <div class="field-error">{{'error.name' | translate}}</div>
                                </ng-container>
                            </div>
                            <div class="field-group flex-1">
                                <label for="secondaryContactPhoneNumber" class="field-label">{{'user.sec_con_phone' | translate}}</label>
                                <div class="input-icon-wrapper">
                                    <i class="fa fa-phone input-icon"></i>
                                    <input id="secondaryContactPhoneNumber" type="text" formControlName="secondaryContactPhoneNumber"
                                           class="form-control modern-input input-with-icon"
                                           [ngClass]="{ 'is-valid': isFieldValid('secondaryContactPhoneNumber'), 'is-invalid': isFieldInvalid('secondaryContactPhoneNumber') }"
                                           maxlength="20" />
                                </div>
                                <ng-container *ngIf="isFieldInvalid('secondaryContactPhoneNumber')">
                                    <div class="field-error">{{'general.invalid_phone_format' | translate}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div><!-- end card-grid -->

        <!-- Custom Fields - full width below grid (conditional) -->
        <div *ngIf="fieldOption" class="profile-card full-width-card mt-1">
            <div class="card-header-section">
                <h3 class="card-title">{{'profile.custom_fields' | translate}}</h3>
            </div>
            <hr>
            <div class="card-body-section">
                <div class="custom-fields-grid">
                    <div class="field-group" *ngFor="let fields of dataSource" formGroupName="custom">
                        <label for="{{fields.id}}" class="field-label">{{fields.field}}</label>
                        <input type="text" id="{{fields.id}}" formControlName="{{fields.id}}" class="form-control modern-input" maxlength="255" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Server Error -->
        <div *ngIf="serverError" class="server-error-banner">
            <i class="fa fa-exclamation-triangle mr-2"></i>
            {{serverError}}
        </div>

        <!-- Action Buttons -->
        <div class="text-right mt-3 mb-2">
            <button type="button" title="{{'general.cancel' | translate}}" routerLink="/main/users" class="btn btn-red btn-h-red mb-2">
                {{'general.cancel' | translate}}
            </button>
            <button type="submit" title="{{'general.add' | translate}}" class="btn btn-green btn-h-green mb-2 ml-2">
                {{'general.add' | translate}}
            </button>
        </div>
    </form>
</div>
